import { render, staticRenderFns } from "./emails.vue?vue&type=template&id=7d961f02"
import script from "./emails.vue?vue&type=script&lang=js"
export * from "./emails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports